import React, { useState } from 'react';
import {
    Paper,
    Box,
    Typography,
    Button,
    CircularProgress,
    Alert,
    IconButton,
    Tooltip
} from '@mui/material';
import {
    Eye,
    CheckCircle
} from 'lucide-react';
import RichTextEditor from '../common/RichTextEditor';

const TextAssignment = ({ assignment, token, onSubmitted }) => {
    const [content, setContent] = useState('');
    const [preview, setPreview] = useState(false);
    const [loading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async () => {
        if (!content.trim()) {
            setError('Ответ не может быть пустым');
            return;
        }
        onSubmitted({ content });
    };

    return (
        <Paper elevation={0} className="border rounded-xl overflow-hidden">
            {/* Заголовок */}
            <Box className="p-4 bg-gray-50 border-b">
                <Typography variant="h6" className="font-medium">
                    {assignment.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" className="mt-1">
                    {assignment.description}
                </Typography>
            </Box>

            {/* Ошибки */}
            {error && (
                <Alert
                    severity="error"
                    className="m-4"
                    onClose={() => setError(null)}
                >
                    {error}
                </Alert>
            )}

            {/* Редактор/Превью */}
            <Box className="p-4">
                {preview ? (
                    <Box className="prose max-w-none min-h-[200px] p-4 border rounded-lg bg-gray-50">
                        <div dangerouslySetInnerHTML={{ __html: content }} />
                    </Box>
                ) : (
                    <RichTextEditor
                        value={content}
                        onChange={setContent}
                        placeholder="Напишите ваш ответ здесь..."
                        toolbar="minimal"
                        enableCodeHighlight={true}
                        enableAutoSave={true}
                        autoSaveKey={`draft_${assignment.id}`}
                        showLastSaved={true}
                        minHeight="200px"
                    />
                )}
            </Box>

            {/* Панель действий */}
            <Box className="p-4 border-t bg-gray-50 flex items-center justify-between">
                <Box className="flex items-center gap-2">
                    <Tooltip title={preview ? "Редактировать" : "Предпросмотр"}>
                        <IconButton
                            onClick={() => setPreview(!preview)}
                            size="small"
                        >
                            <Eye className="w-5 h-5" />
                        </IconButton>
                    </Tooltip>
                </Box>

                <Box className="flex items-center gap-2">
                    <Button
                        startIcon={loading ? <CircularProgress size={16} /> : <CheckCircle />}
                        onClick={handleSubmit}
                        variant="contained"
                        disabled={loading || !content.trim()}
                    >
                        {loading ? 'Отправка...' : 'Отправить ответ'}
                    </Button>
                </Box>
            </Box>
        </Paper>
    );
};

export default TextAssignment;
